export const FILE_EXTENSION_ICONS = {
    'docx': 'icon-file-word-solid',
    'jpg': 'icon-file-image',
    'pptx': 'icon-file-powerpoint-solid',
    'xls': 'icon-file-excel-solid',
    'bmp': 'icon-file-image',
    'gif': 'icon-file-image',
    'dot': 'icon-file-word-solid',
    'jtd': 'icon-file-alt',
    'rft': 'icon-file-word-solid',
    'xlsm': 'icon-file-excel-solid',
    'doc': 'icon-file-word-solid',
    'hwp': 'icon-file-word-solid',
    'html': 'icon-file-code-solid',
    'pdf': 'icon-file-pdf-solid',
    'rtf': ' icon-file-alt',
    'xml': 'icon-file-code-solid',
    'gen': 'icon-file-solid', //general
    'docm': 'icon-file-word-solid',
    'jpeg': 'icon-file-image',
    'ppt': 'icon-file-powerpoint-solid',
    'tiff': 'icon-file-image',
    'xlsx': 'icon-file-excel-solid',
};
